module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "border-bottom py-2"
  }, [_c('div', {
    staticClass: "font-size-16 black--text"
  }, [_vm._v("Data Konsultan")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-7 pb-6"
  }, [_c('v-row', [_c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Student ID ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.detail.student_id),
      callback: function($$v) {
        _vm.$set(_vm.detail, "student_id", $$v)
      },
      expression: "detail.student_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Teacher ID ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.detail.teacher_id),
      callback: function($$v) {
        _vm.$set(_vm.detail, "teacher_id", $$v)
      },
      expression: "detail.teacher_id"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Start Sesi ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.start_time),
      callback: function($$v) {
        _vm.start_time = $$v
      },
      expression: "start_time"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" End Sesi ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.end_time),
      callback: function($$v) {
        _vm.end_time = $$v
      },
      expression: "end_time"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Sesi Terpakai ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.detail.total_session),
      callback: function($$v) {
        _vm.$set(_vm.detail, "total_session", $$v)
      },
      expression: "detail.total_session"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Tambah Sesi ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.detail.add_on),
      callback: function($$v) {
        _vm.$set(_vm.detail, "add_on", $$v)
      },
      expression: "detail.add_on"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pb-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    staticClass: "font-size-12"
  }, [_vm._v(" Chat Room ID ")]), _vm._v(" "), _c('v-text-field', {
    staticClass: "mt-1",
    attrs: {
      "outlined": "",
      "readonly": "",
      "dense": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.detail.id),
      callback: function($$v) {
        _vm.$set(_vm.detail, "id", $$v)
      },
      expression: "detail.id"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pb-3"
  }, [_c('v-btn', {
    attrs: {
      "color": "blew",
      "dark": "",
      "block": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        return _vm.viewChatDetail()
      }
    }
  }, [_vm._v("\n            Detail Chat\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aaf83578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsulActivityDetail.vue
// module id = 1610
// module chunks = 1